import type { UseMutationOptions, UseQueryOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { IRequestException } from 'api/types/requestException';

export interface IValidateTokenProps
    extends UseQueryOptions<IRequestException> {
    token: string;
}

const validateToken = async ({ token }: IValidateTokenProps) => {
    await apiClient.post('email-tokens/validate', {
        json: { token },
    });
};

export const useValidateEmailTokenMutation = (
    options: UseMutationOptions<void, IRequestException, IValidateTokenProps>
) => {
    return useMutation<void, IRequestException, IValidateTokenProps>(
        async (token) => await validateToken(token),
        options
    );
};
